// src/components/sla/ai/SlaFactorBars.js
// Horizontal factor bars (0-100) with the model weight — shows WHY a grade / ranking came out the way it did.
import React, { memo } from 'react';
import { Box, Flex, HStack, Progress, Text, Tooltip, VStack, useColorModeValue } from '@chakra-ui/react';
import { scoreScheme } from './slaAiFormat';

function SlaFactorBars({ factors = {}, labels = {}, weights = null, compact = false }) {
    const muted = useColorModeValue('gray.500', 'gray.400');
    const entries = Object.entries(factors || {}).filter(([, v]) => v !== null && v !== undefined && Number.isFinite(Number(v)));
    if (!entries.length) return <Text fontSize="sm" color={muted}>No factor data.</Text>;
    return (
        <VStack align="stretch" spacing={compact ? 1.5 : 2.5}>
            {entries.map(([k, v]) => {
                const value = Math.max(0, Math.min(100, Number(v)));
                const w = weights?.[k];
                return (
                    <Box key={k}>
                        <Flex justify="space-between" mb={0.5}>
                            <HStack spacing={1}>
                                <Text fontSize={compact ? 'xs' : 'sm'} fontWeight="600">{labels[k] || k.replace(/_/g, ' ')}</Text>
                                {w != null && (
                                    <Tooltip label={`Counts for ${Math.round(w * 100)}% of the score`} hasArrow>
                                        <Text as="span" fontSize="2xs" color={muted}>×{Math.round(w * 100)}%</Text>
                                    </Tooltip>
                                )}
                            </HStack>
                            <Text fontSize={compact ? 'xs' : 'sm'} fontWeight="700">{Math.round(value * 10) / 10}</Text>
                        </Flex>
                        <Progress value={value} size={compact ? 'xs' : 'sm'} borderRadius="full" colorScheme={scoreScheme(value)} aria-label={`${labels[k] || k} ${value}`} />
                    </Box>
                );
            })}
        </VStack>
    );
}

export default memo(SlaFactorBars);
